@if (node() && formGroup()) {
<div class="faction-panel">
    <form class="faction-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden">
                    <a class="tab-link" (click)="onClick(tab)" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
                </li>
                }
            </ul>
        </div>
        <div class="body">
            <div class="row">
                <div class="faction-info">
                    Faction Name: {{node()!.name}}
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
